import React from 'react'
import styled, {withTheme} from 'styled-components'
import get from 'lodash/get'
import breakpoint from 'components/breakpoint'
import {NotificationIcon} from 'components/icons'
import {NOTIFICATION_TYPES} from 'const/notifications'
import {chooseIconColor} from './notifications/utils'

const PageMessageView = styled.div`
  margin-top: 20px;
  display: flex;

  ${breakpoint('portrait')`
    margin-top: ${props => props.theme.notification.pageMessage.marginTop || '40px'};
  `};
`

const getBorderRadius = (props, isRadiusOnLeftSide) => {
  const br = get(props.theme.notification.pageMessage, 'borderRadius', '0px')

  return isRadiusOnLeftSide ? `${br} 0px 0px ${br}` : `0px ${br} ${br} 0px`
}

const PageMessageTextView = styled.div`
  width: 100%;
  font-family: ${props => props.theme.notification.family};
  padding: ${props => props.theme.notification.pageMessage.textPadding || '12px'};
  border: ${props => `2px solid ${props.color}`};
  border-left: 0;
  border-radius: ${props => getBorderRadius(props)};
  font-size: ${props => props.theme.notification.pageMessage.sizeMobile || props.theme.font.size};
  line-height: ${props => props.theme.notification.pageMessage.heightMobile || props.theme.font.height};

  ${breakpoint('portrait')`
    padding: 20px;
    font-size: ${props => props.theme.notification.pageMessage.size};
    line-height: ${props => props.theme.notification.pageMessage.height};
  `};
`

const PageMessageIconView = styled.div`
  background-color: ${props => props.color};
  border-radius: ${props => getBorderRadius(props, true)};
  padding: 12px;
  ${breakpoint('portrait')`
      padding: 20px;
  `};
`

const PageMessageIcon = styled.div`
  color: ${props => chooseIconColor(props.type, props.theme, 'colorFunc')};

  & > svg {
    height: ${props => props.theme.notification.icon.height};
    width: ${props => props.theme.notification.icon.width};

    ${breakpoint('portrait')`
      height: ${props => props.theme.notification.icon.mobile.height};
      width: ${props => props.theme.notification.icon.mobile.width};
    `};
  }
`

const getProps = props => {
  if (props.error) {
    return {color: props.theme.notification.error, type: NOTIFICATION_TYPES.error}
  }
  if (props.info) {
    return {color: props.theme.notification.info, type: NOTIFICATION_TYPES.info}
  }
  if (props.warning) {
    return {color: props.theme.notification.warning, type: NOTIFICATION_TYPES.warning}
  }
  return {color: props.theme.notification.success, type: NOTIFICATION_TYPES.success}
}

const PageMessage = ({children, className, ...props}) => {
  const {color, type} = getProps(props)

  return (
    <PageMessageView className={className}>
      <PageMessageIconView color={color}>
        <PageMessageIcon type={type}>
          <NotificationIcon icon={type} />
        </PageMessageIcon>
      </PageMessageIconView>
      <PageMessageTextView color={color}>{children}</PageMessageTextView>
    </PageMessageView>
  )
}

export default withTheme(PageMessage)
